

import { useReducer } from "react"
import { Box } from "@mui/material"
import DefaultModal from "../../../components/modal/DefaultModal/DefaultModal"
import lockedReducer from "../../../lib/reducer"
import { emitSnackbar } from "../../../lib/snackbar-emitter"
import api, { getEnterpriseId } from "../../../lib/api"
import { RoundedButton } from "../../../components/ui/roundButton"
import { loader } from "../../../lib/loader"
import { Input } from "../../../components/ui/input"
import { formatPhoneNumber } from "../../../services/scout"

const captcha = "remover"
const DeleteAdmin = ({ user, handleClose, handleSuccess }) => {

  const [state, setState] = useReducer(lockedReducer, {
    captcha: "",
  })

  const deleteAdmin = async () => {
    const enterpriseId = getEnterpriseId()
    loader.on()
    const res = await api.delete(
      `/enterprises/${enterpriseId}/users/${user.id}/`,
      { timeout: 30000 }
    );
    if (res.status === 204) {
      emitSnackbar({ message: "Administrador removido com sucesso.", severity: "success" })
      handleClose()
      handleSuccess()
    } else {
      emitSnackbar({ message: "Falha para remover o administrador.", severity: "error" })
    }
    loader.off()
  }

  return (
    <DefaultModal
      title={"Excluir administrador"}
      handleClose={handleClose}
      maxWidth="xs"
      action={
        <Box width="100%" display="flex" gap="1rem" sx={{ justifyContent: "space-between" }}>
          <Box sx={{ width: "100%" }}>
            <RoundedButton onClick={handleClose} rounded="outlined" sx={{ width: "100%" }}>
              Cancelar
            </RoundedButton>
          </Box>
          <Box sx={{ width: "100%" }}>
            <span sx={{ width: "100%" }}>
              <RoundedButton sx={{ width: "100%" }} disabled={captcha !== state.captcha} onClick={() => deleteAdmin()}>
                Salvar
              </RoundedButton>
            </span>
          </Box>
        </Box>
      }
    >
      <Box display="flex" gap="1rem" flexDirection="column">
        <Box className="bg-gray-100 rounded-xl p-4 text-center flex flex-col gap-1" sx={{ background: "#ebf4f6" }}>
          <Box className="font-bold text-sm text-gray-900">{user.name}</Box>
          <Box className="text-sm text-gray-400">{formatPhoneNumber(user.telephone)}</Box>
          <Box className="text-sm text-gray-400">{user.email}</Box>
        </Box>
        <Box className="text-sm text-gray-700">
          Se deseja excluir este número, digite <strong>{captcha}</strong> no campo abaixo:
        </Box>
        <Input
          placeholder="Preencha e confirme"
          value={state.captcha}
          onChange={({ target }) => setState({ captcha: target.value })}
          className="w-full rounded-lg border border-gray-200 px-3 py-2.5 text-sm text-gray-700 placeholder:text-gray-300 outline-none focus:border-gray-300 bg-white"
        />
      </Box>
    </DefaultModal>
  )
}

export default DeleteAdmin
